<template>
  <div class="table-responsive">
    <a-table
      :columns="columns"
      :data-source="dataSource"
      :bordered="true"
      :row-key="(rec) => rec.id"
      :pagination="pagination"
      :scroll="{ x: true }"
      :loading="tableLoading"
    >
      <template #totalBranches="{record}">
        {{ record?.doc?.branches?.length || 'NA' }}
      </template>
      <template #totalBankAccounts="{record}">
        {{ record?.doc?.bankAccounts?.length || 'NA' }}
      </template>
      <template #actions="{record}">
        <div>
          <ButtonGroupActions
            :button-list="actionButtonList"
            @handleEditClick="handleEditClick(record)"
            @handleDeleteClick="handleDeleteClick(record)"
          />
        </div>
      </template>
      <template #expandedRowRender="{record}">
        <div>
          <div>
            <div><h5>Branches</h5></div>
            <BranchesTable :branches-list="record?.doc?.branches" />
          </div>
          <div>
            <div><h5>Bank Accounts</h5></div>
            <BankAccountsTable :bank-accounts-list="record?.doc?.bankAccounts" />
          </div>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, reactive, ref } from 'vue'
import { CompaniesDocument } from '@/types/firebaseCollectionContracts/CompaniesDocument'
import { IAppDocument } from '@/types/interfaces/IAppDocument'
import BranchesTable from './BranchesTable.vue'
import BankAccountsTable from './BankAccountsTable.vue'
import { ActionButtonList } from '@/types/enums/ActionButtonList'
import ButtonGroupActions from '@/components/General/ButtonGroupActions.vue'
import { useStore } from 'vuex'
import { DocumentActions } from '@/types/enums/DocumentActions'
import { DocumentOperation } from '@/types/appcontracts/DocumentOperation'
import * as actions from '@/store/actions.type'

const columns = [
  {
    title: 'Company Name',
    dataIndex: 'doc.name',
    key: 'name',
  },
  {
    title: 'Primary Branch',
    dataIndex: 'doc.primaryBranch',
    key: 'primaryBranch',
  },
  {
    title: 'PAN',
    dataIndex: 'doc.pan',
    key: 'pan',
  },
  {
    title: 'Invoice Prefix',
    dataIndex: 'doc.invoicePrefix',
    key: 'invoicePrefix',
  },
  {
    title: 'Total Branches',
    key: 'totalBranches',
    slots: { customRender: 'totalBranches' },
  },
  {
    title: 'Total Bank Accounts',
    key: 'totalBankAccounts',
    slots: { customRender: 'totalBankAccounts' },
  },
  {
    title: 'Actions',
    key: 'actions',
    slots: { customRender: 'actions' },
  },
]

export default defineComponent({
  name: 'CompaniesTable',
  components: {
    BranchesTable,
    BankAccountsTable,
    ButtonGroupActions,
  },
  props: {
    companiesList: {
      type: Object as PropType<IAppDocument<CompaniesDocument>[] | null>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore()
    const dataSource = computed(() => props.companiesList)
    const totalTableRecords = computed(() => dataSource.value?.length)
    const actionButtonList = [ActionButtonList.EDIT, ActionButtonList.DELETE]
    const tableLoading = ref(false)

    const showTotal = (total: number, range: Array<any>) => {
      return `${range[0]}-${range[1]} of ${total} items`
    }
    const pagination = reactive({
      position: 'bottom',
      showSizeChanger: true,
      showQuickJumper: false,
      total: totalTableRecords.value || 0,
      simple: false,
      pageSize: 10,
      showTotal: showTotal,
    })

    // const handleViewClick = (rec: any) => {
    //   console.log('TODO: View - ', rec)
    // }

    const handleEditClick = (rec: any) => {
      console.log('TODO: EDIT - ', rec)
    }
    const handleDeleteClick = async (rec: IAppDocument<any>) => {
      tableLoading.value = true
      const docOperation: DocumentOperation<null> = {
        action: DocumentActions.DELETE,
        id: rec.id,
        payload: null,
        audit: null,
      }
      await store.dispatch(
        `companies/${actions.CompaniesAction.SET_OR_DELETE_COMPANY}`,
        docOperation,
      )
      tableLoading.value = false
    }
    return {
      columns,
      pagination,
      dataSource,
      // handleViewClick,
      actionButtonList,
      handleEditClick,
      handleDeleteClick,
      tableLoading,
    }
  },
})
</script>

<style lang="scss">
.ant-pagination-item,
.ant-pagination-jump-next,
.ant-pagination-jump-prev {
  display: none !important;
}
</style>
